/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import { UserCircle2, ShieldCheck, Building2, CheckCircle2, ArrowRight, AlertCircle } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';

export const StepIndicator = ({ current, completed }) => {
  const steps = [
    { key: 'tier1', label: 'Identità', Icon: UserCircle2 },
    { key: 'tier2', label: 'Verifica', Icon: ShieldCheck },
    { key: 'tier3', label: 'Studio', Icon: Building2 },
  ];
  return (
    <ol className="flex items-center gap-2 mb-6" data-testid="onboarding-stepper">
      {steps.map((s, i) => {
        const done = completed.includes(s.key);
        const active = current === s.key || current === `${s.key}_awaiting_review`;
        return (
          <li key={s.key} className="flex items-center gap-2 flex-1">
            <div
              className={`flex items-center gap-2 px-3 py-2 rounded-full text-sm font-medium flex-1 ${
                done
                  ? 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-300'
                  : active
                  ? 'bg-primary/10 text-primary'
                  : 'bg-secondary/60 text-muted-foreground'
              }`}
              data-testid={`step-${s.key}`}
            >
              {done ? <CheckCircle2 className="h-4 w-4" /> : <s.Icon className="h-4 w-4" />}
              <span className="whitespace-nowrap">Tier {i + 1} · {s.label}</span>
            </div>
            {i < steps.length - 1 && (
              <ArrowRight className="h-4 w-4 text-muted-foreground flex-shrink-0" aria-hidden="true" />
            )}
          </li>
        );
      })}
    </ol>
  );
};

export const ErrorAlert = ({ error }) => {
  if (!error) return null;
  const message = error?.response?.data?.detail?.message || error?.message || 'Something went wrong.';
  const code = error?.response?.data?.detail?.code;
  return (
    <Alert variant="destructive" className="mb-4" data-testid="onboarding-error">
      <AlertCircle className="h-4 w-4" />
      <AlertDescription>
        {code && <span className="font-mono text-xs opacity-60 mr-2">[{code}]</span>}
        {message}
      </AlertDescription>
    </Alert>
  );
};
